<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j4mOZy/tc-custom/9781595585271.jpg?1734377035212" alt="This image is the cover for the book Economics for the Rest of Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Economics for the Rest of Us
      </h1>
      <p class="bookDescription body article font2">
        <b>“Vivid case studies . . . Adler’s frustration with wrongheaded economic thinking is as entertaining as it is thought provoking.” —<i>Publishers Weekly</i></b><br/>  <br/> Why do so many contemporary economists consider food subsidies in starving countries, rent control in rich cities, and health insurance everywhere “inefficient”? Why do they feel that corporate executives deserve no less than their multimillion-dollar “compensation” packages and workers no more than their meager wages? Here is a lively and accessible debunking of the two elements that make economics the “science” of the rich: the definition of what is efficient and the theory of how wages are determined. The first is used to justify the cruelest policies, the second grand larceny.<br/>  <br/> Filled with lively examples—from food riots in Indonesia to eminent domain in Connecticut and everyone from Adam Smith to Jeremy Bentham to Larry Summers—<i>Economics for the Rest of Us</i> shows how today’s dominant economic theories evolved, how they explicitly favor the rich over the poor, and why they’re not the only or best options. Written for anyone with an interest in understanding contemporary economic thinking—and why it is dead wrong—<i>Economics for the Rest of Us</i> offers a foundation for a fundamentally more just economic system.<br/>  <br/> “Brilliant.” —David Cay Johnston, Pulitzer Prize–winning and <i>New York Times</i>–bestselling author of <i>It’s Even Worse Than You Think</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Moshe Adler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d6ffb420